import type { LocationResourceFailure } from '~/client/src/shared/resources/domain/locationResourceTypeDefinition'
import type { ResourceResult } from '~/client/src/shared/resources/domain/resourceResult'

export function requireLocationResourceSuccess<T>(
  result: ResourceResult<T, LocationResourceFailure>,
): T {
  if (result._tag === 'Ok') return result.value
  if (
    result.error._tag === 'ProjectResourceOperationFailure' &&
    result.error.cause instanceof Error
  ) {
    throw result.error.cause
  }

  switch (result.error._tag) {
    case 'MissingLocationResourceRecord':
      throw new Error(`Cannot save missing location: ${result.error.recordId}`)
    case 'MissingLocationResourceId':
      throw new Error('Location response did not contain an id')
    case 'ProjectResourceOperationFailure':
      throw new Error(`Location operation failed: ${result.error.operation}`)
  }
}
